import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, Star, Users, ArrowRight, Sparkles } from 'lucide-react';

const WebinarPromoSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setIsVisible(true); }, { threshold: 0.1 });
    const section = document.getElementById('webinar-promo');
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="webinar-promo" className="py-24 px-6 bg-gradient-to-br from-[#1e1919] via-[#2a2030] to-[#1e1919] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#9D4EDD]/40 rounded-full blur-3xl animate-pulse-soft" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FF6B9D]/30 rounded-full blur-3xl animate-pulse-soft" style={{ animationDelay: '2s' }} />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <div className="relative rounded-2xl overflow-hidden">
              <div className="aspect-video bg-gradient-to-br from-[#9D4EDD]/20 to-[#FF6B9D]/20 rounded-2xl flex items-center justify-center relative overflow-hidden">
                <video className="absolute inset-0 w-full h-full object-cover opacity-60" loop muted autoPlay playsInline>
                  <source src="https://customer-assets.emergentagent.com/job_bf3299c0-3855-4a52-beac-c89141d44eb4/artifacts/lbt1qcg6_Welcome-GemstoneMinerals.mp4" type="video/mp4" />
                </video>
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e1919] via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-gradient-to-r from-[#c9a96e] to-[#FFB800] text-[#1e1919] px-6 py-3 rounded-xl shadow-xl">
                <span className="font-bold text-lg">$800</span><span className="text-sm ml-1">Value</span>
              </div>
            </div>
          </div>

          <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#c9a96e]/20 border border-[#c9a96e]/40 mb-6">
              <Star className="w-4 h-4 text-[#c9a96e] fill-current" />
              <span className="text-sm text-[#c9a96e] font-semibold tracking-wider uppercase">Live Webinar Event</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">Selenite Healing <span className="text-[#c9a96e]">Mastery</span></h2>
            <p className="text-xl text-white/60 mb-6">with Guest Educator <span className="text-[#FF6B9D] font-semibold">Romona Nicole Schmidt</span></p>
            <p className="text-white/70 leading-relaxed mb-8">Join us for an exclusive live masterclass on the most powerful cleansing crystal on Earth. Learn ancient techniques for space clearing, aura cleansing, and channeling angelic guidance through Selenite.</p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <Calendar className="w-5 h-5 text-[#c9a96e] mb-2" />
                <p className="text-white/50 text-xs uppercase">Date</p>
                <p className="text-white font-semibold">July 2026</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <Clock className="w-5 h-5 text-[#9D4EDD] mb-2" />
                <p className="text-white/50 text-xs uppercase">Duration</p>
                <p className="text-white font-semibold">3 Hours Live</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <Users className="w-5 h-5 text-[#FF6B9D] mb-2" />
                <p className="text-white/50 text-xs uppercase">Limited To</p>
                <p className="text-white font-semibold">50 Participants</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <Sparkles className="w-5 h-5 text-[#FFB800] mb-2" />
                <p className="text-white/50 text-xs uppercase">Includes</p>
                <p className="text-white font-semibold">Selenite Kit</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/webinar-registration" className="group inline-flex items-center gap-3 bg-gradient-to-r from-[#c9a96e] to-[#FFB800] text-[#1e1919] px-8 py-4 rounded-xl font-semibold hover:shadow-2xl transition-all">
                Reserve Your Seat
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link to="/kholey" className="inline-flex items-center gap-3 bg-white/10 border border-white/20 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white/20 transition-all">
                Meet Romona
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebinarPromoSection;
